import React from 'react';
import {Dummy} from '../'

export default class EnergoAll extends Dummy {

    paintCanvas(cvs) {
        var canvas = document.getElementById(cvs);
        if (canvas.getContext) {
            var ctx = canvas.getContext('2d');

            ctx.fillStyle = "#41adad";
            ctx.fillRect(0, 0, 1100, 750);

            ctx.fillStyle = "black";
            ctx.font = "bold 18px Arial";
            ctx.fillText("Узел электрического нагрева ВЕНА-150-А-0-2Р-ЕТ-У-М", 168, 110);

            ctx.lineWidth = 1;

            ctx.setLineDash([6]);
            ctx.strokeRect(15, 85, 716, 515);


            ctx.fillStyle = "red";
            ctx.beginPath();
            ctx.moveTo(411, 5);
            ctx.lineTo(427, 21);
            ctx.lineTo(427, 82);
            ctx.lineTo(395, 82);
            ctx.lineTo(395, 21);
            ctx.lineTo(411, 5);
            ctx.fill();
            ctx.closePath();

            ctx.fillStyle = "black";
            ctx.beginPath();
            ctx.moveTo(392, 45);
            ctx.lineTo(384, 50);
            ctx.lineTo(384, 40);
            ctx.lineTo(392, 45);
            ctx.fill();
            ctx.closePath();

            ctx.fillStyle = "black";
            ctx.beginPath();
            ctx.moveTo(430, 45);
            ctx.lineTo(438, 50);
            ctx.lineTo(438, 40);
            ctx.lineTo(430, 45);
            ctx.fill();
            ctx.closePath();

            ctx.fillStyle = "red";
            ctx.beginPath();
            ctx.moveTo(196, 299);
            ctx.lineTo(196, 357);
            ctx.lineTo(310, 357);
            ctx.lineTo(339, 328);
            ctx.lineTo(310, 299);
            ctx.lineTo(196, 299);
            ctx.fill();
            ctx.closePath();

            ctx.fillStyle = "red";
            ctx.beginPath();
            ctx.moveTo(482, 299);
            ctx.lineTo(482, 357);
            ctx.lineTo(740, 357);
            ctx.lineTo(769, 328);
            ctx.lineTo(740, 299);
            ctx.lineTo(482, 299);
            ctx.fill();
            ctx.closePath();

            ctx.fillStyle = "black";
            ctx.beginPath();
            ctx.moveTo(265, 295);
            ctx.lineTo(260, 287);
            ctx.lineTo(270, 287);
            ctx.lineTo(265, 295);
            ctx.fill();
            ctx.closePath();

            ctx.fillStyle = "black";
            ctx.beginPath();
            ctx.moveTo(265, 361);
            ctx.lineTo(260, 369);
            ctx.lineTo(270, 369);
            ctx.lineTo(265, 361);
            ctx.fill();
            ctx.closePath();

            ctx.fillStyle = "black";
            ctx.beginPath();
            ctx.moveTo(613, 295);
            ctx.lineTo(608, 287);
            ctx.lineTo(618, 287);
            ctx.lineTo(613, 295);
            ctx.fill();
            ctx.closePath();

            ctx.fillStyle = "black";
            ctx.beginPath();
            ctx.moveTo(613, 361);
            ctx.lineTo(608, 369);
            ctx.lineTo(618, 369);
            ctx.lineTo(613, 361);
            ctx.fill();
            ctx.closePath();

            ctx.fillStyle = "black";
            ctx.beginPath();
            ctx.moveTo(478, 486);
            ctx.lineTo(486, 491);
            ctx.lineTo(486, 481);
            ctx.lineTo(478, 486);
            ctx.fill();
            ctx.closePath();

            ctx.beginPath();
            ctx.fillStyle = "#1E90FF";
            ctx.arc(925, 328, 140, 0, Math.PI * 2, true);
            ctx.fill();
        }
    };


    render() {
        return (
            <canvas className='cvs' id={this.props.canvas_id} width="1100" height="750"/>
        );
    }
}

EnergoAll.propTypes = {
    canvas_id: React.PropTypes.string,
};


// WEBPACK FOOTER //
// ./src/components/entries/EnergoAll/index.jsx